/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Button, Colors, Spacer, Typography } from '@zapier/design-system';
import List from '@zapier/product-get-help/esm/components/shared/List';
import Surface from '@zapier/product-get-help/esm/components/shared/Surface';
import ExternalLink from '@zapier/product-get-help/esm/components/shared/ExternalLink';
import ConversationLink from './ConversationLink';
const RebrandStyles = {
    browseLink: Object.assign(Object.assign({}, Typography.smallPrint1Bold), { color: Colors.blueJeans }),
    buttonIntro: Object.assign(Object.assign({}, Typography.paragraph1ShortBold), { color: Colors.neutral800 }),
};
/** Renders the content for the community-step in the form. */
const CommunityStep = ({ links, size = 'large' }) => {
    return (isolateComponent(Surface, { size: size, title: "Find a solution in our Community" },
        isolateComponent(Spacer, { height: 14 }),
        isolateComponent(List, { gap: 5, itemRenderer: (item) => (isolateComponent(ConversationLink, Object.assign({}, item, { size: size }))), items: links }),
        isolateComponent(Spacer, { height: 20 }),
        isolateComponent(ExternalLink, { css: RebrandStyles.browseLink, href: "https://community.zapier.com/ask-the-community-3" }, "Browse Community"),
        isolateComponent(Spacer, { height: 40 }),
        isolateComponent("p", { css: RebrandStyles.buttonIntro }, "You can also ask your own question"),
        isolateComponent(Spacer, { height: 15 }),
        isolateComponent(Button, { color: "secondary", href: "https://community.zapier.com/topic/new", target: "_blank" }, "Ask our Community")));
};
export default CommunityStep;
